import { createFileRoute } from '@tanstack/react-router'
import { CooptationInvitePage } from '@/pages/CooptationInvitePage'

export const Route = createFileRoute('/recommend')({
  component: CooptationInvitePage,
})
